const SvgTooltipTip = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.9 327.421">
    <path
      d="M416.594,14.294c-10.891-19.06-35.4-19.06-46.288,0L283.175,164.05C226,264.8,117.082,327.421,0,327.421H786.9c-117.082,0-223.273-62.626-283.175-163.371L416.594,14.294Z"
      transform="translate(0 0.001)"
    />
  </svg>
);

export default SvgTooltipTip;
